export type LegalDialogId = "imprint" | "privacy";

export function dialogFromHash(hash: string): LegalDialogId | null {
  const normalized = hash.replace(/^#/, "").toLowerCase();
  return normalized === "imprint" || normalized === "privacy"
    ? normalized
    : null;
}

export function hashForDialog(dialog: LegalDialogId): string {
  return "#" + dialog;
}
